import { render } from "./SocketHandlers.vue?vue&type=template&id=6f59c334"
import script from "./SocketHandlers.vue?vue&type=script&lang=js"
export * from "./SocketHandlers.vue?vue&type=script&lang=js"
script.render = render

export default script